import React, { forwardRef, HTMLAttributes } from 'react';
import classNames from 'classnames';
import styles from './Card.module.scss';
// import { CardHeaderProps } from './types';

export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {}

const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(
  ({ className, children, ...props }, ref) => (
    <div className={classNames(styles.header, className)} ref={ref} {...props}>
      {children}
    </div>
  ),
);

CardHeader.displayName = 'Card.Header';

export default CardHeader;
